import {DlRadioSelectOption} from '@wallaby-ui/core';
import * as React from 'react';
import {Options} from 'react-select';

import stylesFilterNode from './FilterNode.less';
import {FilterNodeTypeRadioItem} from './FilterNodeTypeRadioItem';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';
import {
  DynamicFilter,
  Filter,
  FILTER_TYPE_RADIO_ENUM,
} from 'src/js/lib/filtering';
import {
  FilterNode as FilterNodeModel,
  FilterSchema,
} from 'src/js/model/filters_config';

export interface FilterNodeTypeRadioOwnProps {
  inputRef: (inputElement: HTMLInputElement) => void;
  setFocus: () => void;
  isOpened?: boolean;
  node: FilterNodeModel;
  changeFilter: (values: any) => void;
  removeFilter: (filter: Filter) => void;
  schema: FilterSchema;
  selectedFilter?: Filter;
  toggleOpened: () => void;
  options: Options<DlRadioSelectOption<string | number>>;
}

type Props = FilterNodeTypeRadioOwnProps;

export const FilterNodeTypeRadio: React.FC<Props> = (props) => {
  const {
    changeFilter,
    inputRef,
    isOpened = false,
    node,
    removeFilter,
    schema,
    selectedFilter,
    setFocus,
    toggleOpened,
    options,
  } = props;

  const getFilter = () => {
    const SelectFilter = DynamicFilter.getFilterClass(FILTER_TYPE_RADIO_ENUM);
    return new SelectFilter({
      node,
      type: FILTER_TYPE_RADIO_ENUM,
      property: node.getName(),
      value: '',
    });
  };

  const filter = getFilter();

  return (
    <FilterNodeTypeWrapper
      filter={filter}
      isOpened={isOpened}
      node={node}
      removeFilter={removeFilter}
      setFocus={setFocus}
      selectedFilter={selectedFilter}
      toggleOpened={toggleOpened}
    >
      {options.map((item, itemIdx) => {
        return (
          <ul
            className={stylesFilterNode.dlIndentedList}
            key={item.name}
            data-name={item.name}
          >
            <FilterNodeTypeRadioItem
              isOpened={isOpened}
              node={node}
              selectedFilter={selectedFilter}
              changeFilter={changeFilter}
              inputRef={itemIdx === 0 ? inputRef : undefined}
              value={item}
            />
          </ul>
        );
      })}
    </FilterNodeTypeWrapper>
  );
};

FilterNodeTypeRadio.displayName = 'FilterNodeTypeRadio';
